module.exports = __webpack_public_path__ + "img/WordPress.5719e480.png";